module.exports = __webpack_public_path__ + "img/self_referrals.68a5d943.svg";